/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const FilterType = {
  FIRST_APPLICANT: 'firstApplicant',
  LAST_MODIFIED_DATE: 'lastModifiedDate',
  STATUS: 'status',
  TITLE_OF_INVENTION: 'titleOfInvention',
  USER_REFERENCE: 'userReference',
  PUBLICATION_NUMBER: 'publicationNumber',
  APPLICATION_NUMBER: 'applicationNumber',
  SPC_APPLICATION_NUMBER: 'spcApplicationNumber',
  SUBSEQUENT_ACTION_TYPE: 'saType',
  USER_NAME: 'name',
  USER_EMAIL: 'email',
  ROLES: 'roles',
  INVITATION_STATUS: 'invitationStatus',
};

export const InputType = {
  TEXT_FIELD: 'textField',
  DATE_PICKER: 'datePicker',
  STATUS: 'status',
  INVITATION_STATUS: 'invitationStatus',
  DROPDOWN: 'dropdown',
  ROLES: 'roles',
};
